import React from "react";
import styled, { css, keyframes } from "styled-components";

const fadeInAnim = keyframes`
  0%{
     transform: translateY(75px);
     opacity:0
  }
  10%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
    transform: translateY(75px);
    opacity:0
  }
  50%{
    transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
    transform:translateY(-10px);
    opacity:0.5;
  }
  100%{
    transform:translateY(0px)
    opacity:1
   } 
`;

const fadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: translateY(0);
     opacity:1;
    }
    100%{
      transform:translateY(123px);
      opacity:0;
   } 
`;

const fadeIn = css`
  ${fadeInAnim} 0.267s 1 forwards
`;
const fadeOut = css`
  ${fadeOutAnim} 0.55s 1 forwards
`;
const scaleDown = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: scale(1);
     filter: blur(0);
     }
    100%{
      transform: scale(.9);
      filter: blur(15px);
    } 
`;

// animation: ${(p) => (p.fadeOut ? playUnPress : null)};
export const SettingsDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: rgb(127, 61, 165, 0.85);
  animation: ${fadeIn};
  animation: ${(p) => (p.unBlur ? fadeOut : null)};
  animation: ${(p) =>
    p.scaleDown
      ? css`
          ${scaleDown} 0.55s 1 forwards
        `
      : null};

  color: #ffb000;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
  & > div {
    height: 667px;
    width: 375px;
  }
  & > div > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 315px;
    height: 607px;
  }
  & > div > div > label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    max-width: 320px;
    margin: auto;
    line-height: 3.2;
    div {
      text-transform: capitalize;
    }
    input[type="range"] {
      -webkit-appearance: none;
      width: 160px;
      margin: 11.5px 0;
    }
    input[type="range"]:focus {
      outline: none;
    }
    input[type="range"]::-webkit-slider-runnable-track {
      width: 160px;
      height: 3px;
      cursor: pointer;
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
      background: #ffb000;
      border-radius: 1px;
      border: 0px solid rgba(0, 0, 0, 0.95);
    }
    input[type="range"]::-webkit-slider-thumb {
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
      border: 0px solid #000000;
      height: 26px;
      width: 26px;
      border-radius: 13px;
      background: #ffb000;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -11.5px;
    }
    input[type="range"]:focus::-webkit-slider-runnable-track {
      background: #ffb205;
    }
    input[type="range"] {
      background: none;
    }
    input[type="range"]::-moz-range-track {
      width: 160px;
      height: 3px;
      cursor: pointer;
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
      background-color: #ffb000;
      border-radius: 1px;
      border: 0px solid rgba(0, 0, 0, 0.95);
    }
    input[type="range"]::-moz-range-thumb {
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
      border: 0px solid #000000;
      height: 26px;
      width: 26px;
      border-radius: 13px;
      background: #ffb000;
      cursor: pointer;
    }
    input[type="range"]::-ms-track {
      width: 160px;
      height: 3px;
      cursor: pointer;
      background: transparent;
      border-color: transparent;
      color: transparent;
    }
    input[type="range"]::-ms-fill-lower {
      background: #faac00;
      border: 0px solid rgba(0, 0, 0, 0.95);
      border-radius: 2px;
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    }
    input[type="range"]::-ms-fill-upper {
      background: #ffb000;
      border: 0px solid rgba(0, 0, 0, 0.95);
      border-radius: 2px;
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    }
    input[type="range"]::-ms-thumb {
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
      border: 0px solid #000000;
      height: 26px;
      width: 26px;
      border-radius: 13px;
      background: #ffb000;
      cursor: pointer;
      height: 3px;
    }
    input[type="range"]:focus::-ms-fill-lower {
      background: #ffb000;
    }
    input[type="range"]:focus::-ms-fill-upper {
      background: #ffb205;
    }
  }
`;
const btnRotate = keyframes`
0% {
  transform: rotate(-45deg);
  animation-timing-function: cubic-bezier(0.23, 0.07, 0.08, 0.91);
}
33% {
  transform: rotate(13.34deg);
  animation-timing-function: cubic-bezier(0.28, -0.06, 0.61, 0.89);
}
66% {
  transform: rotate(-10.65deg);
  animation-timing-function: cubic-bezier(0.32, -0.18, 0.66, 1);
}
100% {
  transform: rotate(0deg);
}
`;
const btnRotateAnim = css`
  ${btnRotate} 500ms forwards
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 0 30px;
  font-size: 26px;
  /* temp max-width */
  max-width: 320px;
  margin: auto;

  svg {
    animation: ${btnRotateAnim};
    cursor: pointer;

    background: #ffb000;
    padding: 10px;
    border-radius: 50%;
  }
`;
// const animSVG = keyframes`
// 0%{
//   animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
//   transform: scale(1);
// }
// 50%{
//   animation-timing-function: cubic-bezier(0, 0, 0, 1);
//   transform: scale(.65);
// }
// 100%{
//   transform: scale(1);
// }
// `;
const animOther = keyframes`
0%{
  animation-timing-function: cubic-bezier (0.17, 0.17, 0.2, 1);
  opacity:1;

}
33%{
  animation-timing-function: cubic-bezier (0.17, -0.33, 0.2, 1);
  opacity:.5;
}
100%{
   opacity:1;
}
`;

export const OtherPages = styled.div`
  cursor: pointer;
  line-height: 3.2;
  text-transform: none;
  font-size: 20px;
  /* temp max-width */
  max-width: 320px;
  margin: auto;
  animation: ${(p) =>
    p.animSG &&
    css`
      ${animOther} 500ms 1 forwards
    `};
`;
export const GameMode = styled.div`
  /* display: grid;
  grid-template-columns: 30.48% 30.48% 30.48%; */
  display: flex;
  margin: auto;
  padding: 0 0 25px;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  /* temp max-width */
  max-width: 320px;
  margin: auto;
  pointer-events: ${(p) => (p.clickable ? "auto" : "none")};
`;

const activeAnim1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(.3,0,0,1.01);
    border: solid 3px #f9b608;

    color: #FFB000
  }
  100%{
    border: solid 0px #f9b608;

    color:#7F3DA5
  } 
`;
const activeAnim = css`
  ${activeAnim1} 0.05s 1 forwards
`;

const whiteAnim1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity:0;
  }
  33%{
    animation-timing-function: cubic-bezier(.2,.35,.2,1);
    opacity:.5;
  }
  100%{
    opacity:0;
  } 
`;

const whiteAnim = css`
  ${whiteAnim1} 0.33s 1 forwards
`;
const yellowAnim1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity:0;
  }
   
  100%{
    opacity:1;
  } 
`;
const yellowAnim2 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(.3,0,.2,1);
    transform:scale(0.5);
  }
   
  100%{
    transform:scale(1);
  } 
`;
const yellowAnim = css`
  ${yellowAnim1} 0.05s 1 forwards, ${yellowAnim2} 0.17s 1 forwards
`;
const pAnim1 = keyframes`
  0%{
    transform:translateY(3px)
    }
     
   37%{
    transform:translateY(-1px)
   }
   71%{
    transform:translateY(5px)
   }
  100%{
    transform:translateY(3px)
   } 
`;
const pAnim = css`
  ${pAnim1} 0.58s 1 forwards
`;
export const Mode = styled.div`
  position: relative;
  border-radius: 18px;
  width: 96px;
  height: 36px;
  border: solid 3px #f9b608;
  line-height: 1.9;
  cursor: pointer;
  animation: ${(p) => (p.active ? activeAnim : null)};
  .white {
    z-index: -1;
    background: #ffffff;
    height: 100%;
    border-radius: 18px;

    animation: ${(p) => (p.active ? whiteAnim : null)};
  }
  p {
    animation: ${(p) => (p.active ? pAnim : null)};
  }
  .yellow {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: -1;
    width: 92px;
    height: 36px;
    background: #ffb000;
    height: 100%;
    border-radius: 18px;

    animation: ${(p) => (p.active ? yellowAnim : null)};
  }

  font-size: 16px;
`;

export const Volume = ({ saveUserSetting, value, handleVolume }) => {
  let show = false;
  if (value) show = true;
  if (value === 0 || value === "0") show = true;

  return (
    <label>
      <div>Volume</div>
      {show && (
        <input
          onChange={(v) => {
            handleVolume(v.target.value);
          }}
          onMouseUp={(e) => saveUserSetting(e.target.value)}
          onTouchEnd={(e) => saveUserSetting(e.target.value)}
          type="range"
          max="1"
          min="0"
          step="0.1"
          defaultValue={value}
        />
      )}
    </label>
  );
};
